import React from "react";
import SidebarTreeAdvanced from "./SidebarTreeAdvanced";
import {
  servicesTree,
  localizeServicesTree,
} from "../../services/servicesConfigAdvanced";
import { translations, LanguageCode } from "../../utils/translations";

interface SidebarProps {
  onSelect: (id: string) => void;
  lang?: LanguageCode;
}

const Sidebar: React.FC<SidebarProps> = ({ onSelect, lang = "en" }) => {
  const enabledServices = [
    "automation",
    "social",
    "website",
    "tools",
    "integrations",
    "mobileApps",
  ];

  const userServices = localizeServicesTree(
    servicesTree.filter((service) => enabledServices.includes(service.id)),
    lang
  );

  return (
    <div
      className="dashboard-sidebar"
      style={{
        width: "280px",
        background: "#FFFFFF",
        padding: "20px",
        boxShadow: "5px 0 20px rgba(0,0,0,0.05)",
      }}
    >
      <h2
        style={{
          color: "#714B67",
          fontWeight: 800,
          marginBottom: "20px",
        }}
      >
        {translations[lang].dashboard.sidebarTitle}
      </h2>

      <div
        className="dashboard-sidebar__tree"
        style={{
          width: "280px",
          minWidth: "220px",
          background: "#FFFFFF",
          padding: "20px",
          overflow: "auto",
        }}
      >
        <SidebarTreeAdvanced
          data={userServices}
          onSelect={onSelect}
          soonLabel={translations[lang].dashboard.soon}
        />
      </div>
    </div>
  );
};

export default Sidebar;
